export default function NotFoundDetails() {
  return (
    <div>
      <div className="general-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h1>404 Page Not Found</h1>
        </div>

        {/* Start Main Content */}
        <div className="content-fluid">
          <div className="mb-960-center mid-side-outlines mobile-pad-1em">{/* Full Width Element */}
<br/>
<h4 className="center-div">The page you are looking for does not exist</h4>
<br/>
<h4  className="center-div"><a href="/">Click here to visit the Morrisville Borough Home Page</a></h4>


          </div>
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
